export enum PaymentProviderEnum {
    YOOCASSA = 'yoocassa' ,
    STARS = 'stars',
}
